const NAVIGATION_CONTEXTS = {
  "/home": { module: "Dashboard", modulePath: "/home", current: "Asistente financiero AI" },
  "/contador_ai": { module: "Dashboard", modulePath: "/home", current: "Contador AI" },
  "/dashboard_facturador": { module: "Dashboard", modulePath: "/home", current: "Facturador AI" },
  "/flujo_de_caja": { module: "Flujo de caja", modulePath: "/flujo_de_caja" },
  "/estado_resultados": { module: "Estado de resultados", modulePath: "/estado_resultados" },
  "/movimientos_bancarios": { module: "Movimientos", modulePath: "/movimientos_bancarios" },
  "/movimientos_bancarios_v2": { module: "Movimientos", modulePath: "/movimientos_bancarios" },
  "/calendario_financiero": { module: "Calendario financiero", modulePath: "/calendario_financiero", current: "Calendario" },
  "/estados_pagos_cobros": { module: "Calendario financiero", modulePath: "/calendario_financiero", current: "Pagos y cobros" },
  "/pagos_masivos": { module: "Pagos masivos", modulePath: "/pagos_masivos", current: "Generar pagos" },
  "/pagos_masivos/configuracion": { module: "Pagos masivos", modulePath: "/pagos_masivos", current: "Configuración de pagos" },

  "/nueva_factura": { module: "Facturación", modulePath: "/nueva_factura", current: "Emitir documento" },
  "/documentos_emitidos": { module: "Facturación", modulePath: "/nueva_factura", current: "Documentos emitidos" },
  "/emisiones_masivas": { module: "Facturación", modulePath: "/nueva_factura", current: "Emisión masiva" },
  "/cotizaciones": { module: "Facturación", modulePath: "/nueva_factura", current: "Cotizaciones" },
  "/gastos_exterior": { module: "Facturación", modulePath: "/nueva_factura", current: "Gastos del exterior" },
  "/clientes_facturador": { module: "Facturación", modulePath: "/nueva_factura", current: "Clientes" },
  "/productos_facturador": { module: "Facturación", modulePath: "/nueva_factura", current: "Productos y servicios" },
  "/configuracion_cotizaciones": { module: "Facturación", modulePath: "/nueva_factura", current: "Configurar cotizaciones" },
  "/configuracion_facturador": { module: "Facturación", modulePath: "/nueva_factura", current: "Configurar facturador" },

  "/mis_impuestos": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Mis impuestos" },
  "/impuestos_mensuales": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Impuestos mensuales" },
  "/libro_ventas": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Libro de ventas" },
  "/libro_compras": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Libro de compras" },
  "/libro_honorarios": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Libro de honorarios" },
  "/libro_remuneraciones": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Libro de remuneraciones" },
  "/rrhh": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "RRHH" },
  "/documentos": { module: "Contabilidad", modulePath: "/impuestos_mensuales", current: "Documentos" },

  "/resumen_proyectos": { module: "Proyectos", modulePath: "/resumen_proyectos", current: "Resumen de proyectos" },
  "/configuracion_proyecto": { module: "Proyectos", modulePath: "/resumen_proyectos", current: "Matriz de proyectos" },
  "/flujo_proyectos": { module: "Proyectos", modulePath: "/resumen_proyectos", current: "Flujo de caja por proyectos" },

  "/integraciones": { module: "Integraciones", modulePath: "/integraciones", current: "Todas las integraciones" },
  "/integraciones/previred": { module: "Integraciones", modulePath: "/integraciones", current: "Previred" },
  "/integraciones/mercadopago": { module: "Integraciones", modulePath: "/integraciones", current: "Mercado Pago" },
  "/integraciones/shopify": { module: "Integraciones", modulePath: "/integraciones", current: "Shopify" },
  "/mercadopago": { module: "Integraciones", modulePath: "/integraciones", current: "Mercado Pago" },
  "/configuracion_extensiones": { module: "Integraciones", modulePath: "/integraciones", current: "Extensiones" },
  "/clientes": { module: "Contactos", modulePath: "/clientes", current: "Clientes" },
  "/proveedores": { module: "Contactos", modulePath: "/clientes", current: "Proveedores" },
  "/trabajadores": { module: "Contactos", modulePath: "/clientes", current: "Trabajadores" },
  "/configuracion_ingresos": { module: "Configurar mi asistente", modulePath: "/configuracion_ingresos", current: "Matriz de Ingresos" },
  "/configuracion_gastos_costos": { module: "Configurar mi asistente", modulePath: "/configuracion_gastos_costos?costos=1", current: "Matriz de gastos" },
  "/reglas_clasificacion": { module: "Configurar mi asistente", modulePath: "/configuracion_gastos_costos?costos=1", current: "Reglas de clasificación" },
  "/configuracion": { module: "Ajustes", modulePath: "/configuracion", current: "General" },
  "/facturacion_suscripcion": { module: "Ajustes", modulePath: "/configuracion", current: "Mi plan y pagos" },
  "/password": { module: "Ajustes", modulePath: "/configuracion", current: "Cambiar contraseña" },
  "/logo": { module: "Ajustes", modulePath: "/configuracion", current: "Logo de empresa" },
  "/sii": { module: "Ajustes", modulePath: "/configuracion", current: "Información fiscal" },
  "/conexion_bancaria": { module: "Integraciones", modulePath: "/integraciones", current: "Cuentas bancarias" },
  "/mensajes_wsp": { module: "Integraciones", modulePath: "/integraciones", current: "WhatsApp" },
};

const ADMIN_LABELS = {
  "/index_empresas_new": "Empresas",
  "/index_formulario": "Formularios",
  "/adm_cuentas_bancarias": "Cuentas bancarias",
  "/adm_diagnostico_new": "Diagnóstico",
  "/adm_ejecutivos": "Ejecutivos",
  "/adm_ingresos": "Clientes",
  "/adm_suscripciones": "Suscripciones",
  "/adm_crm": "CRM",
  "/adm_growth": "Growth",
  "/adm_agente_ia": "Cerebro IA",
  "/adm_contador": "Contador",
  "/adm_trabajadores_new": "Trabajadores",
  "/adm_tutoriales": "Tutoriales",
  "/adm_proveedores_new": "Proveedores",
  "/proveedores_masivo": "Proveedores masivo",
  "/clasificacion_masiva": "Clasificación masiva",
  "/administrar_proyectos": "Proyectos",
  "/adm_sugerencias": "Sugerencias",
  "/adm_clasificaciones": "Clasificaciones",
  "/adm_usuarios": "Usuarios",
  "/administrar_alarmas": "Alarmas",
  "/asociar_usuario_new": "Asociar usuario",
  "/asociar_empresa": "Asociar empresa",
  "/conciliar_movimientos_new": "Conciliar movimientos",
  "/configurar_eerr": "Configurar EERR",
  "/configurar_limite": "Configurar límite",
  "/configurar_empresa": "Configurar empresa",
  "/graficas": "Gráficos",
  "/webhook_mensajes": "Mensajes de Meta",
  "/subir_health_score": "Health score",
  "/subir_cartola": "Subir cartola",
  "/subir_trabajadores_new": "Subir trabajadores",
  "/subir_proveedores_new": "Subir proveedores",
  "/metricas_northstar": "Métricas North Star",
  "/config_itsave": "Configurar ItSave",
  "/admin_api_config": "Configuración de APIs",
  "/administrar_permisos_empresas": "Permisos de empresas",
  "/administrar_correos_notificaciones": "Correos y notificaciones",
};

const DOCUMENT_TITLE_OVERRIDES = {
  "/home": "Dashboard",
  "/calendario_financiero": "Calendario financiero",
  "/pagos_masivos": "Pagos masivos",
  "/integraciones": "Integraciones",
  "/configuracion": "Ajustes",
};

function normalizePath(pathname) {
  const path = String(pathname || "/").split("?")[0].replace(/\/+$/, "");
  return path || "/";
}

function humanizePath(pathname) {
  const value = normalizePath(pathname).replace(/^\//, "").replace(/[_-]+/g, " ");
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "Inicio";
}

export function getNavigationContext(pathname = window.location.pathname, search = window.location.search) {
  const path = normalizePath(pathname);
  if (path === "/integraciones") {
    const params = new URLSearchParams(search || "");
    const integration = params.get("integracion");
    return {
      ...NAVIGATION_CONTEXTS[path],
      current: integration
        ? integration.charAt(0).toUpperCase() + integration.slice(1).replace(/[-_]+/g, " ")
        : NAVIGATION_CONTEXTS[path].current,
    };
  }
  if (path === "/configuracion_gastos_costos") {
    const params = new URLSearchParams(search || "");
    return {
      ...NAVIGATION_CONTEXTS[path],
      current: params.get("costos") === "1" ? "Matriz de costos" : "Matriz de gastos",
    };
  }
  if (NAVIGATION_CONTEXTS[path]) return NAVIGATION_CONTEXTS[path];
  if (ADMIN_LABELS[path]) {
    return { module: "Administración", modulePath: "/index_empresas_new", current: ADMIN_LABELS[path] };
  }
  return { module: humanizePath(path), modulePath: path, current: "" };
}

export function getDocumentTitle(pathname = window.location.pathname, search = window.location.search) {
  const path = normalizePath(pathname);
  const context = getNavigationContext(path, search);
  const integration = path === "/integraciones"
    ? new URLSearchParams(search || "").get("integracion")
    : null;
  const label = integration
    ? context.current
    : DOCUMENT_TITLE_OVERRIDES[path] || context.current || context.module;
  return label ? `${label} – ItSave` : "ItSave";
}

export function pathMatches(link, pathname = window.location.pathname, search = window.location.search) {
  const target = new URL(link, window.location.origin);
  const currentPath = normalizePath(pathname);
  if (normalizePath(target.pathname) !== currentPath) return false;
  if (currentPath === "/integraciones" && !target.search && search) return false;
  if (!target.search) return true;
  return target.searchParams.toString() === new URLSearchParams(search || "").toString();
}
